import React from "react";
import mainLogo from "../assets/images/unum-logo.png";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import OrganizationLogo from "./OrganizationLogo";
import { displayLogo } from "../constants/index";
import { matchReportUrl } from "../utils/helpers";

function Footer() {
    const { currentSelectedOrganization } = useSelector(
        (state) => state.organizations
    );
    const location = useLocation();
    let url = location.pathname;

    let urlDisplay = url.match(displayLogo);
    const reportUrl = matchReportUrl(url);
    const currentYear = new Date().getFullYear();

    return (
        <footer className="py-20p footer" id="footer">
            <div
                className={`d-flex justify-content-between ${reportUrl ? " mx-54p" : "container"
                    }`}
            >
                <div>
                    <p className="copyright mb-10p">
                        &copy; {currentYear} Unum Group. All rights reserved.
                    </p>

                    <p className="copyright mb-0">
                        Unum is a registered trademark and marketing brand of
                        Unum Group and its <br /> insuring subsidiaries.
                        Insurance products are underwritten by the <br />
                        subsidiaries of Unum Group.
                    </p>
                </div>

                <div className="d-flex justify-content-right align-items-end">
                    <img
                        src={mainLogo}
                        className="logo mr-17p"
                        alt=""
                        style={{ marginRight: 17 }}
                        tabIndex={-1}
                    />
                    <div>
                        {urlDisplay !== null && (
                            <OrganizationLogo
                                organizationName={
                                    currentSelectedOrganization?.ORGNIZATIONNAME
                                }
                                label={true}
                                width={89.99}
                                height={26.47}
                                div={false}
                            />
                        )}
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
